/**
 * Bundle Builder (Shopify)
 * Final version (ACTUAL / current)
 * - Robust money formatting (amount / amount_with_comma_separator / amount_no_decimals)
 * - Safer variant price handling (cents number or "price" string)
 * - Prevents double init & duplicate submits
 * - Updates main "Your setup price" reliably:
 *   #BundleTotalPriceMain OR [data-bundle-total-main]
 * - Works even if main price element is outside [data-bundle-root]
 * - Event delegation (works with dynamic DOM)
 * - Centralized cart add helper with basic error handling
 */

document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-bundle-root]');
  if (!root) return;

  // Avoid double init if section is re-rendered
  if (root.dataset.bundleInit === '1') return;
  root.dataset.bundleInit = '1';

  // Bundle total element inside bundle builder
  // Supports: .bundle-total-price (your liquid) or legacy #BundleTotalPrice
  var totalEl = root.querySelector('.bundle-total-price') || root.querySelector('#BundleTotalPrice');
  if (!totalEl) return;

  var rows = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-row]'));
  var summaryEl = root.querySelector('[data-bundle-summary]');

  function getMainPriceEl() {
    // main product header price (outside root) OR alternative hook
    return (
      document.getElementById('BundleTotalPriceMain') ||
      document.querySelector('[data-bundle-total-main]')
    );
  }

  // Money format can live on bundle total OR on main price element
  var mainPriceElInit = getMainPriceEl();
  var moneyFormat =
    totalEl.getAttribute('data-money-format') ||
    (mainPriceElInit && mainPriceElInit.getAttribute('data-money-format')) ||
    '{{amount}}';

  function normalizePriceToCents(price) {
    // Supports:
    // - number (cents)
    // - string "12345" (cents)
    // - string "123.45" / "123,45" (major units) -> convert to cents
    if (price == null) return 0;

    if (typeof price === 'number' && isFinite(price)) return Math.round(price);

    if (typeof price === 'string') {
      var s = price.trim();
      if (!s) return 0;

      // Pure digits => cents
      if (/^\d+$/.test(s)) return parseInt(s, 10);

      // "123.45" or "123,45" => major units
      var normalized = s.replace(',', '.');
      var n = parseFloat(normalized);
      if (isFinite(n)) return Math.round(n * 100);
    }

    return 0;
  }

  function formatNumberEU(cents, decimals) {
    decimals = typeof decimals === 'number' ? decimals : 2;

    var value = cents / 100;
    var fixed = value.toFixed(decimals);
    var parts = fixed.split('.');
    var intPart = parts[0];
    var decPart = parts[1] || '';

    // thousands "." and decimal ","
    var withThousands = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    if (decimals === 0) return withThousands;
    return withThousands + ',' + decPart;
  }

  function applyMoneyFormat(format, formattedAmount) {
    var out = format;
    out = out.replace('{{amount_with_comma_separator}}', formattedAmount);
    out = out.replace('{{ amount_with_comma_separator }}', formattedAmount);
    out = out.replace('{{amount}}', formattedAmount);
    out = out.replace('{{ amount }}', formattedAmount);
    return out;
  }

  function formatMoney(cents) {
    cents = Math.max(0, Math.round(cents || 0));

    var usesNoDecimals =
      moneyFormat.indexOf('amount_no_decimals') !== -1 ||
      moneyFormat.indexOf('amount_no_decimals_with_comma_separator') !== -1;

    var amount = formatNumberEU(cents, usesNoDecimals ? 0 : 2);

    var out = moneyFormat;

    // no_decimals tokens
    if (usesNoDecimals) {
      out = out
        .replace('{{amount_no_decimals}}', amount)
        .replace('{{ amount_no_decimals }}', amount)
        .replace('{{amount_no_decimals_with_comma_separator}}', amount)
        .replace('{{ amount_no_decimals_with_comma_separator }}', amount);
    }

    // default tokens
    out = applyMoneyFormat(out, amount);

    return out;
  }

  function findVariantById(variants, variantId) {
    var idStr = String(variantId);
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === idStr) return variants[i];
    }
    return variants[0] || null;
  }

  function getRowData(row) {
    var includeCheckbox = row.querySelector('.bundle-include');
    if (includeCheckbox && !includeCheckbox.checked) return null;

    var qty = parseInt(row.getAttribute('data-qty') || '1', 10);
    if (!isFinite(qty) || qty < 1) qty = 1;

    var select = row.querySelector('.bundle-variant-select');
    if (!select) return null;

    var variantsJson = select.getAttribute('data-variants') || '[]';
    var variants;
    try {
      variants = JSON.parse(variantsJson);
    } catch (e) {
      console.error('Bundle variants JSON parse error', e, variantsJson);
      return null;
    }
    if (!Array.isArray(variants) || !variants.length) return null;

    var variantId = select.tagName === 'SELECT' ? select.value : variants[0].id;
    var selected = findVariantById(variants, variantId);
    if (!selected) return null;

    var priceCents = normalizePriceToCents(selected.price);

    return {
      variant: selected,
      qty: qty,
      priceCents: priceCents
    };
  }

  function updateMainPrice(bundleTotal) {
    var mainPriceEl = getMainPriceEl();
    if (!mainPriceEl) return;

    // If money format is defined on the main element, prefer it
    var mf = mainPriceEl.getAttribute('data-money-format');
    if (mf) moneyFormat = mf;

    mainPriceEl.textContent = formatMoney(bundleTotal);
  }

  function recalc() {
    // Re-fetch rows in case the section content changed dynamically
    rows = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-row]'));

    var bundleTotal = 0;
    var selectedCount = 0;

    rows.forEach(function (row) {
      var data = getRowData(row);
      var lineEl = row.querySelector('.bundle-line-price');

      if (!data) {
        if (lineEl) lineEl.textContent = formatMoney(0);
        return;
      }

      // Skip unavailable variant in totals (keep consistent with add-to-cart)
      if (data.variant && data.variant.available === false) {
        if (lineEl) lineEl.textContent = formatMoney(0);
        return;
      }

      selectedCount += 1;

      var lineTotal = data.priceCents * data.qty;
      bundleTotal += lineTotal;

      if (lineEl) lineEl.textContent = formatMoney(lineTotal);
    });

    totalEl.textContent = formatMoney(bundleTotal);
    updateMainPrice(bundleTotal);

    if (summaryEl) {
      summaryEl.textContent =
        'Bundle will add all ' +
        selectedCount +
        ' selected item' +
        (selectedCount === 1 ? '' : 's') +
        ' to cart with specified quantities.';
    }
  }

  function collectBundleItems() {
    var items = [];
    rows.forEach(function (row) {
      var data = getRowData(row);
      if (!data) return;

      if (data.variant && data.variant.available === false) return;

      items.push({
        id: data.variant.id,
        quantity: data.qty
      });
    });
    return items;
  }

  function cartAddItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) {
        return res
          .json()
          .catch(function () {
            return null;
          })
          .then(function (errJson) {
            var err = new Error('Cart add failed');
            err.details = errJson;
            throw err;
          });
      }
      return res.json().catch(function () {
        return null;
      });
    });
  }

  // Initial calc + safety recalcs (Shopify sections can reflow after load)
  recalc();
  setTimeout(recalc, 50);
  setTimeout(recalc, 250);

  // Event delegation for variant select & include checkbox
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;

    if (t.matches('select.bundle-variant-select') || t.matches('.bundle-include')) {
      recalc();
    }
  });

  // "Add this item to cart" – add only this row, stay on page
  root.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.bundle-add-single') : null;
    if (!btn) return;

    var row = btn.closest('[data-bundle-row]');
    var data = row ? getRowData(row) : null;
    if (!data) return;
    if (data.variant && data.variant.available === false) return;

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Added';

    cartAddItems([{ id: data.variant.id, quantity: data.qty }])
      .then(function () {
        window.location.reload();
      })
      .catch(function (err) {
        console.error('Add single bundle item failed', err);
        btn.disabled = false;
        btn.textContent = originalText;
      });
  });

  // "Add complete kit to cart" – add all included rows, go to cart
  var addAllBtn = root.querySelector('.bundle-add-all');
  if (addAllBtn) {
    addAllBtn.addEventListener('click', function () {
      var items = collectBundleItems();
      if (!items.length) return;

      addAllBtn.disabled = true;

      cartAddItems(items)
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function (err) {
          console.error('Add full bundle failed', err);
          window.location.href = '/cart';
        });
    });
  }

  // Main product form – intercept only if this product is a bundle and has bundle items
  var mainForm = document.querySelector('form.js-product-form-main');
  if (mainForm && !mainForm.dataset.bundleBound) {
    mainForm.dataset.bundleBound = '1';

    mainForm.addEventListener(
      'submit',
      function (event) {
        var items = collectBundleItems();
        if (!items.length) return; // not a bundle, let Shopify default

        event.preventDefault();
        event.stopImmediatePropagation();

        // Prevent double submit
        if (mainForm.dataset.submitting === '1') return;
        mainForm.dataset.submitting = '1';

        cartAddItems(items)
          .then(function () {
            window.location.href = '/cart';
          })
          .catch(function (err) {
            console.error('Add bundle via main form failed', err);
            window.location.href = '/cart';
          });
      },
      true
    );
  }
});